import React from 'react';

import MultipleChoice from '../../../../elements/forms/MultipleChoice';
import Scrollable from '../../../../elements/Scrollable';
import Screen from '../../../Screen';
import QuestionFooter from '../../common/QuestionFooter/QuestionFooter';
import QuestionHeader from '../../common/QuestionHeader/QuestionHeader';

export default class MultipleChoiceQuestion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: null,
        };
    }
    render() {
        let {event, question, i18n} = this.props,
            header = <QuestionHeader {...this.props} />,
            footer = <QuestionFooter {...this.props} onVote={this.handleVote.bind(this)} disabled={!this.state.value || !this.state.value.length} />,
            input = (
                <MultipleChoice
                    value={this.state.value}
                    options={question.options}
                    checkboxColor={this.props.settings.backgroundText}
                    checkboxBackground={this.props.settings.background}
                    maxOptions={1}
                    onChange={this.handleChange.bind(this)}
                />
            );
        return (
            <Screen header={header} footer={footer} className="LiveVoting">
                <Scrollable>{input}</Scrollable>
            </Screen>
        );
    }
    handleChange(value) {
        this.setState({value});
    }
    handleVote() {
        let value = this.state.value[0],
            option = this.props.question.options.find(option => option.value == value);
        if (option) {
            this.props.onVote(option.id);
        }
    }
}
